import { Filter, isWhitespaceString } from '@ami/react/core';
import MachineMakeAndModelFilter from '../machines/machineMakeAndModelFilter';

export class OrderFilterConfiguration {
  constructor(json) {
    if (json) {
      this.makes = json.makes;
      this.models = json.models;
      this.statuses = json.statuses;
      this.dealerGroups = json.dealerGroups;
      this.amiUsers = json.amiUsers;
      return;
    }
    this.makes = [];
    this.models = [];
    this.statuses = [];
    this.dealerGroups = [];
    this.amiUsers = [];
  }
}

export class OrderFilter extends MachineMakeAndModelFilter {
  constructor(json) {
    super(json);
    if (json) {
      this.search = json.search;
      this.status = json.status;
      this.startDate = json.startDate;
      this.endDate = json.endDate;
      this.shipDateStartDate = json.shipDateStartDate;
      this.shipDateEndDate = json.shipDateEndDate;
      this.serialNumber = json.serialNumber;
      this.dealerItemId = json.dealerItemId;
      this.dealerGroupId = json.dealerGroupId;
      this.dealerBranchId = json.dealerBranchId;
      this.dealerContactId = json.dealerContactId;
      this.contactAmiUserId = json.contactAmiUserId;
      this.isForRecentWidget = json.isForRecentWidget;
      this.onlyAssignedToCurrentUser = json.onlyAssignedToCurrentUser;
      this.shippingLocationCountry = json.shippingLocationCountry;
      this.shippingLocationRegion = json.shippingLocationRegion;
      // These are just to pre-populate the async dropdowns.
      this.dealerGroupName = json.dealerGroupName;
      this.dealerBranchName = json.dealerBranchName;
      this.dealerContactName = json.dealerContactName;
      this.partNumber = json.partNumber;
      this.onlyActives = json.onlyActives;
      this.industryId = json.industryId;
      this.industryName = json.industryName;
      return this;
    }
    this.search = '';
    this.status = null;
    this.startDate = null;
    this.endDate = null;
    this.shipDateStartDate = null;
    this.shipDateEndDate = null;
    this.serialNumber = '';
    this.dealerItemId = '';
    this.dealerGroupId = null;
    this.dealerBranchId = null;
    this.dealerContactId = null;
    this.contactAmiUserId = null;
    this.isForRecentWidget = false;
    this.onlyAssignedToCurrentUser = false;
    this.shippingLocationCountry = null;
    this.shippingLocationRegion = null;
    this.partNumber = null;
    this.onlyActives = false;
    this.industryId = null;
    this.industryName = '';
  }

  toPayload() {
    return {
      ...this,
      search: isWhitespaceString(this.search) ? null : this.search,
      dealerGroupName: undefined,
      dealerBranchName: undefined,
      dealerContactName: undefined,
      startDate: this.mapDate(this.startDate),
      endDate: this.mapDate(this.endDate),
      shipDateStartDate: this.mapDate(this.shipDateStartDate),
      shipDateEndDate: this.mapDate(this.shipDateEndDate),
    };
  }
}

export class UnconfirmedShipmentsFilter extends Filter {
  constructor(filter) {
    super();
    if (filter) {
      this.workOrderNumber = filter.workOrderNumber;
      this.startDate = filter.startDate;
      this.endDate = filter.endDate;
      return this;
    }
    this.workOrderNumber = '';
    this.startDate = null;
    this.endDate = null;
  }

  toPayload() {
    return {
      ...this,
      startDate: this.mapDate(this.startDate),
      endDate: this.mapDate(this.endDate),
    };
  }
}

export class DocumentsLookupFilter extends Filter {
  constructor(filter) {
    super();
    if (filter) {
      this.partNumberPrefix = filter.partNumberPrefix ?? '';
      this.serialNumber = filter.serialNumber ?? '';
      this.orderId = filter.orderId ?? '';
      this.documentId = filter.documentId ?? '';
      this.poNumber = filter.poNumber ?? '';
      this.searchOption = filter.searchOption;
      return this;
    }
    this.partNumberPrefix = '';
    this.serialNumber = '';
    this.orderId = '';
    this.documentId = '';
    this.poNumber = '';
    this.searchOption = null;
  }
}
